import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import SidebarContent from "./SidebarContent";
import { Sheet, SheetContent } from "../components/ui/sheet";
import { Toaster } from "../components/ui/sonner";
import { Menu, Activity } from "lucide-react";

export default function AppShell({ children, refreshKey }) {
  const [key] = useState(refreshKey || 0);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#ffffff] text-[#111827]">
      <Sidebar refreshKey={key} />

      <main className="flex-1 min-w-0">
        {/* Mobile top bar — hidden on md+ */}
        <header
          data-testid="mobile-topbar"
          className="md:hidden sticky top-0 z-30 flex items-center justify-between px-4 h-14 bg-white/85 backdrop-blur border-b border-[#e5e7eb]"
        >
          <button
            data-testid="brand-home"
            onClick={() => navigate("/")}
            className="flex items-center gap-2"
            aria-label="Trace home"
          >
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center">
              <Activity size={14} className="text-white" strokeWidth={2.4} />
            </div>
            <span className="text-[15px] font-semibold tracking-tight text-[#111827]">Trace</span>
          </button>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setMobileOpen(true)}
            className="w-9 h-9 rounded-md flex items-center justify-center text-[#1f2937] hover:bg-[#f3f4f6] transition"
            aria-label="Open menu"
          >
            <Menu size={20} strokeWidth={2.2} />
          </button>
        </header>

        {children}
      </main>

      {/* Mobile drawer */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent
          side="left"
          data-testid="mobile-drawer"
          className="w-[82%] max-w-[320px] bg-[#f7f8fa] border-r border-[#e5e7eb] p-5 overflow-y-auto"
        >
          <SidebarContent refreshKey={key} onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <Toaster position="bottom-right" />
    </div>
  );
}
